export function showToast(
  toast: any,
  message: string,
  description: string,
  status: 'success' | 'warning' | 'error' | 'info',
  t: any,
  duration = 3000,
) {
  toast({
    title: t(message),
    description: t(description),
    status, // Pode ser "info", "warning", "error", ou "success"
    duration, // Tempo em milissegundos (5000ms = 5 segundos)
    isClosable: true, // Permite que o usuário feche a notificação manualmente
  });
}
